export enum ScheduleTypeEnum {
    Planned = 1,
    OneTime = 2,
    Group = 3
}